export default "__VITE_ASSET__BWIr7iNO__"